import Button from 'components/Form/Button';
import React from 'react';

type Props = {
  question: string;
  fieldName: string;
  error: string;
  fieldValue: boolean | string;
  handleChange: (fieldName: string, fieldValue: boolean | string) => void;
};

export default function Question({
  question,
  fieldName,
  handleChange,
  error,
  fieldValue
}: Props) {
  return (
    <div className="mt-5 flex flex-col items-center">
      <p className="w-[20rem] text-xl font-normal text-[#353535]">{question}</p>
      <div className="mt-5 flex items-center gap-x-16 px-4">
        <Button
          variant="outline"
          size="sm"
          className={`w-[7rem] rounded border-[#353535] p-[0.1rem] ${
            fieldValue === true ? 'border-none bg-[#FF6600] text-white' : ''
          }`}
          label="YES"
          type="button"
          onClick={() => handleChange(fieldName, true)}
        ></Button>
        <Button
          variant="outline"
          size="sm"
          className={`w-[7rem] rounded border-[#353535] p-[0.1rem] ${
            fieldValue === false ? 'border-none bg-[#FF6600] text-white' : ''
          }`}
          label="NO"
          type="button"
          onClick={() => handleChange(fieldName, false)}
        ></Button>
      </div>
      {error && (
        <p className="mt-2 text-center text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}
